/**
 * CountryAlignmentIndicator — tiny ✓/⚠️ pill for RevenueBenchmarkPanel.
 *
 * Renders ✓ "in-country" when matched startup operates in algorithm's #1 country,
 * ⚠️ "outside" with the country code when not. This is the gold-signal the
 * Day 3 analysis surfaced: most matched comps operate OUTSIDE the algorithm's
 * top country, which is the whole "BETTER outside US" arbitrage story.
 */
import React from "react";
import { Check, AlertTriangle } from "lucide-react";

const CountryAlignmentIndicator = ({ matched_country, top_country }) => {
  if (!matched_country) {
    return (
      <span
        data-testid="alignment-unknown"
        className="inline-flex items-center gap-1 text-xs font-mono text-zinc-400"
      >
        country: unknown
      </span>
    );
  }
  const aligned = matched_country === top_country;
  if (aligned) {
    return (
      <span
        data-testid="alignment-aligned"
        className="inline-flex items-center gap-1 text-xs font-mono text-emerald-700 bg-emerald-50 px-2 py-0.5 border border-emerald-200"
      >
        <Check size={12} strokeWidth={3} />
        in-country ({matched_country})
      </span>
    );
  }
  return (
    <span
      data-testid="alignment-divergent"
      className="inline-flex items-center gap-1 text-xs font-mono text-amber-700 bg-amber-50 px-2 py-0.5 border border-amber-300"
      title="Match operates in a different country than algorithm's #1 recommendation — possible arbitrage signal"
    >
      <AlertTriangle size={12} strokeWidth={3} />
      arbitrage ({matched_country})
    </span>
  );
};

export default CountryAlignmentIndicator;
